import type {
  Action,
  ActionGoBack,
  ActionGoNext,
  ActionSubmitAndGoNext
} from '@epilot/journey-logic-commons'
import { clsx } from '@epilot/journey-logic-commons'

import { Typography } from '../../components'

import classes from './ActionBarControl.module.scss'
import { ActionButtons } from './ActionButtons'

export const ActionBarControl = ({
  error,
  showError,
  ctaButton,
  goBackButton,
  stepBlockId,
  onAction
}: {
  error?: string
  showError?: boolean
  ctaButton?: ActionGoNext | ActionSubmitAndGoNext
  goBackButton?: ActionGoBack
  stepBlockId: string
  onAction: (action: Action) => void
}) => {
  return (
    <>
      <Typography
        className={clsx(
          classes.errorMessage,
          showError ? classes.displayBlock : classes.displayNone
        )}
        variant="error"
      >
        {error}
      </Typography>
      <ActionButtons
        ctaButton={ctaButton}
        goBackButton={goBackButton}
        id={stepBlockId}
        onAction={onAction}
      />
    </>
  )
}
